const EXPERIMENTS = {
  checkoutNow: {
    defaultEnabled: false,
    growthbookKey: 'checkout-now',
    analyticsName: 'checkoutNow', // Key pushed to GA4 dataLayer
    buttonSelector: '.js-checkout-now-experiment-button',
  },
};

const state = {};
const pushedExperiments = new Set();

function getButtonText(button, enabled) {
  return enabled ? button.dataset.treatmentText : button.dataset.controlText;
}

function getCheckoutTermsNote(button) {
  const group = button.closest('.collation-buttons, .mobile-sticky-wrapper, .book-course');
  if (!group) return null;

  return group.querySelector('.checkout-now-terms-note')
    || (group.nextElementSibling?.matches('.checkout-now-terms-note') ? group.nextElementSibling : null);
}

function applyCheckoutNow(enabled) {
  document.querySelectorAll('add-to-cart-component').forEach((container) => {
    if (!(container instanceof HTMLElement)) return;

    container.dataset.directCheckout = enabled ? 'true' : 'false';

    const text = getButtonText(container, enabled);
    const textElement = container.querySelector('.add-to-cart-text__content');

    if (text && textElement) {
      textElement.textContent = text;
    }

    const note = container.querySelector('.checkout-now-terms-note');
    if (note) note.hidden = !enabled;
  });

  document.querySelectorAll(EXPERIMENTS.checkoutNow.buttonSelector).forEach((button) => {
    if (!(button instanceof HTMLElement)) return;

    const text = getButtonText(button, enabled);

    if (text) {
      button.textContent = text;
    }

    const note = getCheckoutTermsNote(button);
    if (note) note.hidden = !enabled;
  });
}

/**
 * Utility to push experiment state to GA4 dataLayer.
 * This serves as a centralized, easily-inspected place for all experimental dataLayer events.
 *
 * @param {string} name - The internal experiment key
 * @param {boolean} value - Whether the experiment treatment is enabled/active
 */
function pushExperimentToDataLayer(name, value) {
  const config = EXPERIMENTS[name];
  if (!config) return;

  window.dataLayer = window.dataLayer || [];
  
  const variant = value ? 'treatment' : 'control';
  const analyticsName = config.analyticsName || name;
  const cacheKey = `${analyticsName}:${variant}`;

  // Avoid duplicate dataLayer pushes on the same page load for the same state
  if (pushedExperiments.has(cacheKey)) {
    return;
  }

  // Clear older states for this experiment if they exist (e.g. if updated dynamically)
  pushedExperiments.forEach((key) => {
    if (key.startsWith(`${analyticsName}:`)) {
      pushedExperiments.delete(key);
    }
  });

  pushedExperiments.add(cacheKey);

  const payload = {
    event: 'experiment_impression',
    experiment_name: analyticsName,
    experiment_value: variant,
  };

  // Provide a highly visible, easy-to-read console log for inspecting dataLayer pushes
  console.log(`[ICSEExperiments] Pushed to dataLayer:`, payload);

  window.dataLayer.push(payload);
}

function apply(name) {
  if (name === 'checkoutNow') {
    applyCheckoutNow(Boolean(state.checkoutNow));
  }
}

function set(name, enabled) {
  if (!Object.prototype.hasOwnProperty.call(EXPERIMENTS, name)) return;

  state[name] = Boolean(enabled);
  apply(name);
  pushExperimentToDataLayer(name, state[name]);
}

function isEnabled(name) {
  return Boolean(state[name]);
}

function redirectCartToCheckout() {
  const form = document.createElement('form');
  const checkoutInput = document.createElement('input');

  form.method = 'post';
  form.action = '/cart';
  form.style.display = 'none';

  checkoutInput.type = 'hidden';
  checkoutInput.name = 'checkout';
  checkoutInput.value = 'Checkout';

  form.appendChild(checkoutInput);
  document.body.appendChild(form);
  form.submit();
}

window.ICSEExperiments = {
  set,
  apply,
  isEnabled,
  redirectCartToCheckout,
  pushExperimentToDataLayer,
  override: set, // Generic override method for clean, centralized console testing of any experiment
};

// Backwards-compatible legacy helper
window.setCheckoutNowExperiment = (enabled) => {
  window.ICSEExperiments.set('checkoutNow', enabled);
};

// Initialize with default states
Object.entries(EXPERIMENTS).forEach(([name, config]) => {
  set(name, config.defaultEnabled);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => apply('checkoutNow'));
} else {
  apply('checkoutNow');
}

// Integrate GrowthBook SDK queue
window.growthbook_queue = window.growthbook_queue || [];
window.growthbook_queue.push((gb) => {
  const evaluateAll = () => {
    Object.entries(EXPERIMENTS).forEach(([name, config]) => {
      if (config.growthbookKey) {
        const enabled = gb.isOn(config.growthbookKey);
        window.ICSEExperiments.set(name, enabled);
      }
    });
  };

  // Run initial evaluation
  evaluateAll();

  // Re-run evaluation if GrowthBook receives real-time updates or attribute changes
  gb.setRenderer(() => {
    evaluateAll();
  });
});
